import $ from 'jquery';
/* eslint-disable */
let div, isMenuOpen;

/* eslint-enable */
$(document).ready(() => {
  isMenuOpen = false;
  $('body').on('click', '.navbar-toggle', () => {
    if (isMenuOpen) {
      $('.sidebar').hide();
      $('html').removeClass('nav-open');
      $('#bodyClick').remove();
      isMenuOpen = false;
      setTimeout(() => {
        $('.navbar-toggle').removeClass('toggled');
      }, 100);
    } else {
      $('.sidebar').show();
      $('.navbar-toggle').addClass('toggled');
      div = '<div id="bodyClick"></div>';
      isMenuOpen = true;
    }
  });
});



// WEBPACK FOOTER //
// ./src/asset/js/paper-dashboard.js